module.exports = __webpack_public_path__ + "img/illusion.8c34efe.png";